module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-cover-2-0ed5eff00f980f883286c8fbbc18b947.jpg";